module.exports = __webpack_public_path__ + "img/ValidationReport_3.3249e558.jpg";